import styles from "./Login.module.scss";
import { useTranslation } from "react-i18next";
import { Form } from "antd";
import { Link, useNavigate } from "react-router-dom";
import FormItemInput from "../../../components/ui/FormItemInput/FormItemInput";
import FormItemInputPassword from "../../../components/ui/FormItemInputPassword/FormItemInputPassword";
import CustomButton from "../../../components/ui/CustomButton/CustomButton";
import { emailValidation } from "../../../helper/auth";
import { AuthService } from "../../../services/auth.service";
import useAppDispatch from "../../../hooks/useAppDispatch";
import { login } from "../../../store/userProfile/userProfileSlice";
import { openErrorMessage } from "../../../store/message/messageSlice";
import { handleError } from "../../../helper/errorHandler";

const Login = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const onFinish = async (values: { email: string; password: string }) => {
    const model = {
      email: values.email.trim(),
      password: values.password.trim(),
    };

    if (!emailValidation(model.email)) {
      dispatch(openErrorMessage(t("PleaseEnterYourEmailCorrectly")));
      return;
    }

    try {
      const response = await AuthService.login(model as { email: string; password: string });
      if (response?.status === 200) {
        const res = await AuthService.getCurrentUser();
        if (res && res.status === 200) {
          dispatch(login(res.data));
          navigate("/");
        } else {
          dispatch(openErrorMessage(t("SOMETHING_WENT_WRONG")));
        }
      } else {
        dispatch(openErrorMessage(t("SOMETHING_WENT_WRONG")));
      }
    } catch (e) {
      handleError(e, dispatch, t);
    }
  };

  return (
    <div className={styles.formWrapper}>
      <div className={styles.box}>
        <h2 className={styles.title}>{t("WelcomeBack")}</h2>
        <Form
          className={styles.form}
          name="login"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          autoComplete="off"
          layout={"vertical"}
        >
          <FormItemInput name={"email"} label={t("EmailAddress")} rules={{ required: true }} />
          <FormItemInputPassword
            name={"password"}
            label={t("Password")}
            rules={{ required: true }}
          />

          <div className={styles.forgot}>
            <Link to={"/auth/forgot-password"}>{t("ForgotYourPassword")}</Link>
          </div>

          <div className={styles.btnWrapper}>
            <CustomButton text={t("SignIn")} type={"submit"} typeStyle={"fill"} />
          </div>
        </Form>
      </div>
    </div>
  );
};

export default Login;
